import Hb from '@honeybadger-io/js';
import Rb from 'rollbar';

declare const Rollbar: Rb;
declare const Honeybadger: typeof Hb;

export function handleError(
  e: Error,
  customMessage: string | void,
  allowThrow = true
): void {
  if (typeof Honeybadger !== 'undefined') {
    if (customMessage) {
      Honeybadger.notify(e, { message: customMessage });
    } else {
      Honeybadger.notify(e);
    }
  } else if (typeof Rollbar !== 'undefined') {
    if (customMessage) {
      Rollbar.error(customMessage, e);
    } else {
      Rollbar.error(e);
    }
  } else if (allowThrow) {
    throw e;
  }
}
